import $api from 'http'
import $apiJSON from 'http/apiJSON'
import { normalizeVehiclePayload } from './VehicleNumberService'

export const resetDriverPin = (id, actorPin) => $apiJSON.post(`/tabel/drivers/${id}/reset-pin/`, { actor_pin: String(actorPin ?? '') })
export const resetOperatorPin = (id, actorPin) => $apiJSON.post(`/tabel/top-base-operators/${id}/reset-pin/`, { actor_pin: String(actorPin ?? '') })
export const resetGuardPin = (id, actorPin) => $apiJSON.post(`/tabel/guards/${id}/reset-pin/`, { actor_pin: String(actorPin ?? '') })
export const changeGuardInn = (id, inn, actorPin) => $apiJSON.post(`/tabel/guards/${id}/change-inn/`, { inn: String(inn ?? '').trim(), actor_pin: String(actorPin ?? '') })
export const changeOperatorInn = (id, inn, actorPin) => $apiJSON.post(`/tabel/top-base-operators/${id}/change-inn/`, { inn: String(inn ?? '').trim(), actor_pin: String(actorPin ?? '') })
export const getDriverDetail = id => $api.get(`/tabel/drivers/${id}/`)
export const changeDriverInn = (id, inn, actorPin) => $apiJSON.post(`/tabel/drivers/${id}/change-inn/`, { inn: String(inn ?? '').trim(), actor_pin: String(actorPin ?? '') })
export const getAvailableDriverPeople = params => $api.get('/tabel/drivers/available-people/', { params })
export const checkDriverAssignmentInn = inn => $api.get('/tabel/drivers/check-assignment-inn/', { params: { inn } })
export const assignTransportDriver = (id, employeeId, expectedEmployeeId, actorPin) => $apiJSON.post(`/tabel/drivers/${id}/assign-driver/`, { employee_id: employeeId, expected_employee_id: expectedEmployeeId, actor_pin: String(actorPin ?? '') })
export const releaseTransportDriver = (id, expectedEmployeeId, actorPin) => $apiJSON.post(`/tabel/drivers/${id}/release-driver/`, { expected_employee_id: expectedEmployeeId, actor_pin: String(actorPin ?? '') })
export const registerTransportDriver = (id, formData) => $api.post(`/tabel/drivers/${id}/register-driver/`, formData)

const driverBasePayload = (actorPin, expectedDriver) => {
  const payload = { actor_pin: String(actorPin ?? '') }
  if (expectedDriver) {
    const baseType = ['top_base', 'chpp', 'private_point'].find(type => expectedDriver[type] != null) || null
    payload.expected_base_type = baseType
    payload.expected_base_id = baseType ? expectedDriver[baseType] : null
    payload.expected_employee_id = expectedDriver.employee ?? null
  }
  return payload
}
export const assignDriverBase = (id, baseType, baseId, actorPin, expectedDriver) => $apiJSON.post(`/tabel/drivers/${id}/assign-base/`, { [baseType]: baseId, ...driverBasePayload(actorPin, expectedDriver) })
export const changeDriverBase = (id, baseType, baseId, actorPin, expectedDriver) => $apiJSON.post(`/tabel/drivers/${id}/change-base/`, { [baseType]: baseId, ...driverBasePayload(actorPin, expectedDriver) })
export const removeDriverBase = (id, actorPin, expectedDriver) => $apiJSON.post(`/tabel/drivers/${id}/remove-base/`, driverBasePayload(actorPin, expectedDriver))

export async function getMyMembers(service, data) {
  return $api.get(`/employees/teams/${service}/`, data)
}


export async function createNewTeam(name_team) {
  return $apiJSON.post('/employees/commands/', { name_team })
}
export async function AnswerToInvite(id, members) {
  return $apiJSON.patch(`/employees/command/${id}/`, members)
}

// Guard (Охранник КПП)
export async function createGuard(payload) {
  // payload: { employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/guards/', payload)
}

export async function getGuards(params) {
  // params: optional query params for pagination/filtering
  return $api.get('/tabel/guards/', { params })
}

// TopBase (ТОП-База)
export async function createTopBase(payload) {
  // payload: { name: string, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-bases/', payload)
}

export async function getTopBases(params) {
  return $api.get('/tabel/top-bases/', { params })
}

// TopBaseOperator (Оператор ТОП-базы)
export async function createTopBaseOperator(payload) {
  // payload: { top_base: id, employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-base-operators/', payload)
}

export async function getTopBaseOperators(params) {
  return $api.get('/tabel/top-base-operators/', { params })
}

export async function updateTopBaseOperator(id, payload) {
  return $apiJSON.patch(`/tabel/top-base-operators/${id}/`, payload)
}

// Driver (Водитель)
export async function createDriver(payload) {
  // payload: { employee: id, vehicle_number: string, vehicle_model?: string, phone?: string }
  // If uploading files (photo), ensure $apiJSON supports multipart form data.
  return $apiJSON.post('/tabel/drivers/', normalizeVehiclePayload(payload))
}

export async function getDrivers(params) {
  return $api.get('/tabel/drivers/', { params })
}

export const checkBaseOperatorInn = (inn, location) => $api.get('/tabel/top-base-operators/check-inn/', { params: { inn, ...location } })

export function getFilteredDrivers({ page = 1, search = '', statusFilter = '', transportStatus = '' } = {}) {
  return getDrivers({ page, ...(search ? { search } : {}), ...(statusFilter ? { status_filter: statusFilter } : {}),
    ...(transportStatus ? { transport_status: transportStatus } : {}) })
}

export async function updateDriver(id, payload) {
  return $apiJSON.patch(`/tabel/drivers/${id}/`, normalizeVehiclePayload(payload))
}

export const setDriverActive = (id, isActive, actorPin) => $apiJSON.post(`/tabel/drivers/${id}/set-active/`, { is_active: isActive, actor_pin: String(actorPin ?? '') })

export async function blockDriver(id, reason) {
  return $apiJSON.post(`/tabel/drivers/${id}/block/`, { reason: reason?.trim() })
}

export async function unblockDriver(id) {
  return $apiJSON.post(`/tabel/drivers/${id}/unblock/`)
}

export async function getAllEmployees(data) {
  return $api.get(`/employees/all-employees/`, data)
}

export async function updateGuard(id, payload) {
  return $apiJSON.patch(`/tabel/guards/${id}/`, payload)
}

export async function updateTopBase(id, payload) {
  return $apiJSON.patch(`/tabel/top-bases/${id}/`, payload)
}

// =========================
// CHPP (ТЭЦ) — duplicated logic from TopBase
// NOTE: Endpoint names assumed. Adjust if backend differs.
// =========================
export async function createChpp(payload) {
  // payload: { name: string, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/chpps/', payload)
}

export async function getChpps(params) {
  return $api.get('/tabel/chpps/', { params })
}

export async function updateChpp(id, payload) {
  return $apiJSON.patch(`/tabel/chpps/${id}/`, payload)
}

// CHPP Operator (Оператор ТЭЦ)
export async function createChppOperator(payload) {
  // payload: { chpp: id, employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-base-operators/', payload)
}

export async function getChppOperators(params) {
  return $api.get('/tabel/top-base-operators/', { params })
}

export async function updateChppOperator(id, payload) {
  return $apiJSON.patch(`/tabel/top-base-operators/${id}/`, payload)
}

// Drivers for CHPP reuse /tabel/drivers/ with query param chpp
// Existing createDriver/getDrivers/updateDriver already suitable; just pass { chpp: <id> } where needed.

// =========================
// PrivatePoint (Соц. Объекты и МСУ)
// =========================
export async function createPrivatePoint(payload) {
  // payload: { name: string, phone?: string, is_active?: boolean, geo?: string }
  return $apiJSON.post('/tabel/private-points/', payload)
}

export async function getPrivatePoints(params) {
  return $api.get('/tabel/private-points/', { params })
}

export async function updatePrivatePoint(id, payload) {
  return $apiJSON.patch(`/tabel/private-points/${id}/`, payload)
}

// PrivatePoint Operator (Оператор соц.объекта или МСУ)
export async function createPrivatePointOperator(payload) {
  // payload: { private_point: id, employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-base-operators/', payload)
}

export async function getPrivatePointOperators(params) {
  return $api.get('/tabel/top-base-operators/', { params })
}

export async function updatePrivatePointOperator(id, payload) {
  return $apiJSON.patch(`/tabel/top-base-operators/${id}/`, payload)
}

// Drivers for PrivatePoint reuse /tabel/drivers/ with query param private_point
// Existing createDriver/getDrivers/updateDriver already suitable; just pass { private_point: <id> } where needed.

// =========================
// Branches (Филиалы)
// =========================
export async function getTopBaseBranches(topBaseId, params) {
  return $api.get(`/tabel/top-bases/${topBaseId}/branches/`, { params })
}

export async function createTopBaseBranch(topBaseId, payload) {
  // payload: { name: string, address?: string, geo?: string, is_active?: boolean }
  return $apiJSON.post(`/tabel/top-bases/${topBaseId}/branches/`, payload)
}

export async function getChppBranches(chppId, params) {
  return $api.get(`/tabel/chpps/${chppId}/branches/`, { params })
}

export async function createChppBranch(chppId, payload) {
  return $apiJSON.post(`/tabel/chpps/${chppId}/branches/`, payload)
}

export async function getPrivatePointBranches(privatePointId, params) {
  return $api.get(`/tabel/private-points/${privatePointId}/branches/`, { params })
}

export async function createPrivatePointBranch(privatePointId, payload) {
  return $apiJSON.post(`/tabel/private-points/${privatePointId}/branches/`, payload)
}

export async function updateBranch(id, payload) {
  return $apiJSON.patch(`/tabel/branches/${id}/`, payload)
}

export const deleteBranch = (id, actorPin) => $apiJSON.delete(`/tabel/branches/${id}/`, { data: { actor_pin: String(actorPin ?? '') } })

export async function getBranches(params) {
  return $api.get('/tabel/branches/', { params })
}

// =========================
// Driver Documents
// =========================
export async function uploadDriverDocuments(driverId, files) {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files', file)
  })
  return $api.post(`/tabel/drivers/${driverId}/upload_documents/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function getDriverDocuments(driverId) {
  return $api.get(`/tabel/drivers/${driverId}/documents/`)
}

export async function deleteDriverDocument(driverId, documentId) {
  return $api.delete(`/tabel/drivers/${driverId}/documents/${documentId}/`)
}

// TopBase Operator Documents (ТЭЦ, МСУ, соц.объекты)
// =========================
export async function uploadOperatorDocuments(operatorId, files) {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files', file)
  })
  return $api.post(`/tabel/top-base-operators/${operatorId}/upload_documents/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function getOperatorDocuments(operatorId) {
  return $api.get(`/tabel/top-base-operators/${operatorId}/documents/`)
}

export async function deleteOperatorDocument(operatorId, documentId) {
  return $api.delete(`/tabel/top-base-operators/${operatorId}/documents/${documentId}/`)
}

// =========================
// Search (Поиск баз для быстрого выбора)
// =========================
export async function searchTopBases(search, limit = 20, { activeOnly = false } = {}) {
  return $api.get('/tabel/search/top-bases/', { params: { search, limit, ...(activeOnly ? { is_active: true } : {}) } })
}

export async function searchChpps(search, limit = 20, { activeOnly = false } = {}) {
  return $api.get('/tabel/search/chpps/', { params: { search, limit, ...(activeOnly ? { is_active: true } : {}) } })
}

export async function searchPrivatePoints(search, limit = 20, { activeOnly = false } = {}) {
  return $api.get('/tabel/search/private-points/', { params: { search, limit, ...(activeOnly ? { is_active: true } : {}) } })
}
